<!--
 * @Description: 登录（PC3.0）
 * @Author:  wang.y
-->
<template>
  <Modal v-model="modelIndex" width="530" class="login-model" @on-cancel="close" @on-visible-change="resetForms" :footer-hide="true">
    <div class="container-wrapper">
      <img :src="static_img_url + 'pic/pc30/model-bg.png'" class="model-bg" />
      <div class="container-content" v-show="pageStatus == 1">
        <div class="container-top">
          <div class="container-title">登录</div>
          <Tabs v-model="tabName" @on-click="handleChangeStatus($event, 1)">
            <TabPane label="微信扫码" name="wxcode">
              <div class="code-app">
                <p class="linp1">打开<span class="wx">微信</span><br />扫码关注公众号登录</p>
                <div class="wxcode-img">
                  <img :src="codeImg" v-if="codeImg" />
                  <div class="wxcode-p" v-if="codeOut" @click="getQrCode">
                    <p>二维码已过期</p>
                    <a>刷新</a>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane label="APP扫码" name="appcode">
              <div class="code-app">
                <p class="linp1">打开<span class="vb">动脉网App</span><br />在「我的」右上角打开扫一扫</p>
                <template v-if="!appScanStatus">
                  <div class="wxcode-img">
                    <img :src="codeImg" v-if="codeImg" />
                    <div class="wxcode-p" v-if="codeOut" @click="getAppLoginCode">
                      <p>二维码已过期</p>
                      <a>刷新</a>
                    </div>
                  </div>
                </template>
                <div class="scan-view" v-else>
                  <img :src="static_img_url + 'pic/form-success.png'" />
                  <p class="p1">扫码成功</p>
                  <p class="p2">请在手机上确认登录</p>
                </div>
              </div>
            </TabPane>
            <TabPane label="验证码/密码" name="code">
              <Form ref="password-form" :model="passwordForm" :rules="ruleValidate" v-show="codeType == 2">
                <FormItem prop="mobile">
                  <Input type="text" v-model="passwordForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
                </FormItem>
                <FormItem prop="password">
                  <Input type="password" password v-model="passwordForm.password" placeholder="请输入密码" autocomplete="off"></Input>
                </FormItem>
                <div class="form-bottom">
                  <span @click="handleChangeCode(1)" class="spa1">验证码登录</span>
                  <span @click="handleChangeStatus('', 2)">忘记密码？</span>
                </div>
              </Form>
              <Form ref="code-form" :model="codeForm" :rules="ruleValidate" v-show="codeType == 1">
                <FormItem prop="mobile">
                  <Input type="text" v-model="codeForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
                </FormItem>
                <FormItem v-if="ncStatus && pageStatus == 1 && loginWay == 'code-form'">
                  <div class="nc-cnt">
                    <div id="nc"></div>
                  </div>
                </FormItem>
                <FormItem prop="code">
                  <Input type="text" v-model="codeForm.code" placeholder="请输入验证码" autocomplete="off"></Input>
                  <span class="code-btn" @click="haddleCode" v-if="codeStatus == 0">获取验证码</span>
                  <span class="code-btn" @click="haddleCode" v-if="codeStatus == 3">重新获取</span>
                  <span class="code-btn disabled-btn" v-if="codeStatus == 1">验证中</span>
                  <span class="code-btn disabled-btn" v-if="codeStatus == 2">{{wait}}s后重新获取</span>
                </FormItem>
                <div class="form-bottom">
                  <span @click="handleChangeCode(2)" class="spa1">密码登录</span>
                </div>
              </Form>
            </TabPane>
          </Tabs>
        </div>
        <div class="container-bottom">
          <p class="tip" v-if="tabName == 'code'">未注册的手机号将自动创建动脉网账号</p>
          <Button class="submit-btn" type="primary" @click="handleSubmit" v-if="tabName == 'code'" :loading="submitLoading">登录</Button>
          <div class="checkbox-container">
            <div class="checkbox-tip-content" v-if="visible">
              <div class="checkbox-tip-arrow"></div>
              <div class="checkbox-tip-inner">请阅读并勾选下方协议</div>
            </div>
            <Checkbox v-model="readSingle" size="small" @on-change="visible = false" :disabled="tabName != 'code'">
              <p class="checkbox-label">我已阅读并同意<a :href="index2_path+'/mobile/privacyPolicy/2'" target="_blank">《动脉网用户协议》</a>、<a :href="index2_path+'/mobile/privacyPolicy/1'" target="_blank">《隐私政策》</a></p>
            </Checkbox>
          </div>
        </div>
      </div>
      <div class="container-content" v-show="pageStatus == 2">
        <div class="container-top">
          <div class="container-title reset-form-title">忘记密码</div>
          <Form ref="reset-form" :model="updateForm" :rules="ruleValidate">
            <FormItem prop="mobile">
              <Input type="text" v-model="updateForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            </FormItem>
            <FormItem v-if="ncStatus && pageStatus == 2 && loginWay == 'reset-form'">
              <div class="nc-cnt">
                <div id="nc"></div>
              </div>
            </FormItem>
            <FormItem prop="password">
              <Input type="password" password v-model="updateForm.password" placeholder="请输入密码" autocomplete="new-password"></Input>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="updateForm.code" placeholder="请输入验证码" autocomplete="off"></Input>
              <span class="code-btn" @click="haddleCode" v-if="codeStatus == 0">获取验证码</span>
              <span class="code-btn" @click="haddleCode" v-if="codeStatus == 3">重新获取</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 1">验证中</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 2">{{wait}}s后重新获取</span>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom">
          <Button class="submit-btn" type="primary" @click="updatePassword" :loading="submitLoading">重置密码</Button>
        </div>
      </div>
      <div class="container-content" v-show="pageStatus == 3">
        <div class="container-top">
          <div class="container-title reset-form-title">绑定手机号</div>
          <Form ref="biding-form" :model="bidingMobileForm" :rules="ruleValidate">
            <FormItem prop="mobile">
              <Input type="text" v-model="bidingMobileForm.mobile" placeholder="请输入手机号" autocomplete="off"></Input>
            </FormItem>
            <FormItem v-if="ncStatus && pageStatus == 3">
              <div class="nc-cnt">
                <div id="nc"></div>
              </div>
            </FormItem>
            <FormItem prop="code">
              <Input type="text" v-model="bidingMobileForm.code" placeholder="请输入验证码" autocomplete="off"></Input>
              <span class="code-btn" @click="haddleCode" v-if="codeStatus == 0">获取验证码</span>
              <span class="code-btn" @click="haddleCode" v-if="codeStatus == 3">重新获取</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 1">验证中</span>
              <span class="code-btn disabled-btn" v-if="codeStatus == 2">{{wait}}s后重新获取</span>
            </FormItem>
          </Form>
        </div>
        <div class="container-bottom">
          <Button class="submit-btn" type="primary" @click="bidingMobile" :loading="submitLoading">确定绑定</Button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import {
  Achecksendmobliecode,
  Alogin,
  Aresetpassword,
  AqrCodeCreateTmpTicket,
  Aaccountbinding,
  Agetappscanurl,
} from '../service'
import { mapState } from 'vuex'
import { atten_common } from '@/assets/js/atten_common'
import QRCode from 'qrcode'
import Cookies from 'js-cookie'
export default {
  mixins: [atten_common],
  inject: ['reload'],
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index2_path,
      index2_path: (state) => state.index2_path,
      img_req_url: (state) => state.img_req_url,
    }),
  },
  data() {
    return {
      modelIndex: false,
      tabName: 'wxcode',
      loginWay: '',
      passwordForm: {
        mobile: '',
        password: '',
      },
      codeForm: {
        mobile: '',
        code: '',
      },
      updateForm: {
        mobile: '',
        password: '',
        code: '',
      },
      bidingMobileForm: {
        mobile: '',
        code: '',
      },
      ruleValidate: {
        mobile: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          {
            type: 'number',
            message: '手机号格式不正确',
            trigger: 'blur',
            transform(value) {
              let reg = /^1[3456789]\d{9}$/
              if (!reg.test(value)) {
                return false
              } else {
                return Number(value)
              }
            },
          },
        ],
        password: [
          {
            required: true,
            message: '密码最少8位，需包含字母和数字',
            trigger: 'blur',
            validator(rule, value) {
              let reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
              return reg.test(value)
            },
          },
          { max: 20, message: '密码长度不能超过20个字符', trigger: 'blur' },
        ],
        code: [{ required: true, message: '请填写正确的验证码', trigger: 'blur' }],
      },
      pageStatus: 1,
      readSingle: true,
      visible: false,
      codeStatus: 0,
      waitInterval: '',
      wait: 60,
      ncStatus: false,
      codeInterval: '',
      codeImg: '',
      sceneId: '',
      bidingUser: '',
      codeTime: 0,
      codeOut: 0,
      appCodeImg: '',
      appCodeToken: '',
      appScanStatus: 0,
      codeType: 1, // 1动脉网app  2微信
      submitLoading: false,
      loginCallBack: null,
    }
  },
  methods: {
    close() {
      this.modelIndex = false
    },
    updatePassword() {
      if (this.submitLoading) return
      this.$refs['reset-form'].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let res = await Aresetpassword(this.updateForm)
          this.submitLoading = false
          if (res.code == 0) {
            this.handleChangeStatus(this.tabName, 1)
          } else {
            this.$Message.error(res.msg)
          }
        }
      })
    },
    handleSubmit() {
      if (this.submitLoading) return
      this.$refs[this.loginWay].validate(async (valid) => {
        if (valid) {
          if (!this.readSingle) {
            this.visible = true
            return
          }
          let params = {}
          if (this.loginWay == 'code-form') {
            params = {
              ...{
                loginPlatform: 1,
                type: 2,
              },
              ...this.codeForm,
            }
          } else if (this.loginWay == 'password-form') {
            params = {
              ...{
                loginPlatform: 1,
                type: 1,
              },
              ...this.passwordForm,
            }
          }
          this.submitLoading = true
          let res = await Alogin(params)
          this.submitLoading = false
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            this.$Message.error(res.msg)
          }
        }
      })
    },
    loginSuccess(data) {
      if (data.loginFlag == 2) {
        this.$Message.error('请绑定手机号码')
        this.handleChangeStatus('', 3)
        this.bidingUser = { ...data.xuser }
        return
      }
      this.$Message.success('登录成功')
      Cookies.set('user_key_' + this.$store.state.cookie_type, data.userKey, {
        domain: this.$store.state.domain_path,
        path: '/',
        expires: this.$store.state.oneYearFromNow
      })
      this.$store.commit('updateUserKey', data.userKey)
      this.$store.commit('updateUser', data.xuser)
      this.$store.commit('setUUserId', data.xuser.id)
      // return
      this.modelIndex = false
      document.body.removeAttribute('style')
      this.getSubscribeList()
      this.reload()
      if (this.loginCallBack) this.loginCallBack()
    },
    haddleCode() {
      this.ncStatus = false
      const _this = this
      this.$refs[this.loginWay].validateField('mobile', async (valid) => {
        if (!valid) {
          this.codeStatus = 1
          window.nvc.getNVCValAsync(function (nvcVal) {
            _this.checkUserBehavior(nvcVal)
          })
        }
      })
    },
    /**
     * 获取验证码
     */
    async checkUserBehavior(nvcVal) {
      let mobile, scene
      if (this.pageStatus == 2) {
        mobile = this.updateForm.mobile
        scene = 'vbdata_updatepass'
      } else if (this.pageStatus == 3) {
        mobile = this.bidingMobileForm.mobile
        scene = 'vbdata_bidingmobile'
      } else {
        if (this.loginWay == 'code-form') {
          mobile = this.codeForm.mobile
          scene = 'vbdata_loginon'
        }
      }
      let res = await Achecksendmobliecode({
        data: nvcVal,
        mobile,
        scene,
      })
      if (res.code == 0) {
        if (res.data.code == 100 || res.data.code == 200) {
          this.codeStatus = 2
          this.waitInterval = setInterval(() => {
            this.wait--
            if (this.wait == 0) {
              this.codeStatus = 3
              this.wait = 60
              clearInterval(this.waitInterval)
            }
          }, 1000)
          this.ncStatus = false
          this.$Message.success('验证码发送成功')
        } else if (res.data.code == 400) {
          this.ncStatus = true
          var ncoption = {
            renderTo: 'nc',
          }
          this.$nextTick(() => {
            window.nvc.getNC(ncoption)
          })
        } else {
          this.codeStatus = 3
          this.$Message.error('验证被拦截，请稍后再试或联系客服')
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    handleChangeStatus(name, value) {
      clearInterval(this.codeInterval)
      this.readSingle = false
      this.pageStatus = value
      this.codeImg = ''
      if (value == 1) {
        switch (name) {
          case 'code':
            this.handleChangeCode(1)
            break
          case 'wxcode':
            this.loginWay = ''
            this.readSingle = true
            this.getQrCode()
            break
          case 'appcode':
            this.loginWay = ''
            this.readSingle = true
            this.getAppLoginCode()
            break
        }
      } else if (value == 2) {
        this.loginWay = 'reset-form'
      } else if (value == 3) {
        this.loginWay = 'biding-form'
      }
      this.clearForms()
    },
    resetForms(value) {
      if (value) this.getQrCode()
      else {
        clearInterval(this.codeInterval)
        this.codeType = 1
        this.loginWay = ''
        this.tabName = 'wxcode'
        this.pageStatus = 1
        this.codeImg = ''
        this.codeTime = 0
        this.codeOut = 0
        this.readSingle = true
        this.clearForms()
      }
    },
    clearForms() {
      this.$refs['code-form'].resetFields()
      this.$refs['password-form'].resetFields()
      this.$refs['reset-form'].resetFields()
      this.$refs['biding-form'].resetFields()
      this.visible = false
      this.codeStatus = 0
      this.wait = 60
      clearInterval(this.waitInterval)
    },
    handleChangeCode(name) {
      this.codeType = name
      this.clearForms()
      switch (name) {
        case 1:
          this.loginWay = 'code-form'
          break
        case 2:
          this.loginWay = 'password-form'
          break
      }
    },
    async getQrCode() {
      let res = await AqrCodeCreateTmpTicket({
        appid: 'wx93f12cd83e68833d',
      })
      if (res.code == 0) {
        this.$set(this.$data, 'sceneId', res.data.sceneId)
        QRCode.toDataURL(res.data.url, { margin: 1 }).then((url) => {
          this.codeImg = url
        })
        this.codeTime = 0
        this.codeOut = 0
        this.codeInterval = setInterval(this.wxCodeLogin, 2000)
      }
    },
    async getAppLoginCode() {
      let res = await Agetappscanurl({})
      if (res.code == 0) {
        this.$set(this.$data, 'appCodeToken', res.data.token)
        QRCode.toDataURL(res.data.url, {
          margin: 1,
          errorCorrectionLevel: 'L',
        }).then((url) => {
          this.codeImg = url
        })
        console.log(this.codeImg)
        this.codeTime = 0
        this.codeOut = 0
        this.appScanStatus = 0
        this.codeInterval = setInterval(this.appCodeLogin, 2000)
      }
    },
    async wxCodeLogin() {
      this.codeTime++
      if (this.codeTime >= 120) {
        this.codeOut = 1
        clearInterval(this.codeInterval)
        return
      }
      let res = await Alogin({
        appId: 'wx93f12cd83e68833d',
        code: this.sceneId,
        type: 5,
        loginPlatform: 1,
      })
      if (res.code == 2001002011) return
      clearInterval(this.codeInterval)
      if (res.code == 0) {
        this.loginSuccess(res.data)
      } else {
        this.$Message.error(res.msg)
      }
    },
    async appCodeLogin() {
      this.codeTime++
      if (this.codeTime >= 120) {
        this.codeOut = 1
        clearInterval(this.codeInterval)
        return
      }
      let res = await Alogin({
        code: this.appCodeToken,
        type: 6,
        loginPlatform: 1,
      })
      if (res.code == 0) {
        if (res.data.scanStatus == 2) {
          clearInterval(this.codeInterval)
          this.getAppLoginCode()
          return
        }
        this.$set(this.$data, 'appScanStatus', res.data.scanStatus)
        if (!res.data.userKey) return
        clearInterval(this.codeInterval)
        this.loginSuccess(res.data)
      } else {
        clearInterval(this.codeInterval)
        this.$Message.error(res.msg)
      }
    },
    bidingMobile() {
      if (this.submitLoading) return
      this.$refs['biding-form'].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let res = await Aaccountbinding({
            code: this.bidingMobileForm.code,
            mobile: this.bidingMobileForm.mobile,
            type: 2,
            xuser: this.bidingUser,
            loginPlatform: 1,
          })
          this.submitLoading = false
          if (res.code == 0) {
            this.loginSuccess(res.data)
          } else {
            this.$Message.error(res.msg)
          }
        }
      })
    },
  },
  mounted() {
    const _this = this
    AWSC.use('nvc', function (state, module) {
      window.nvc = module.init({
        appkey: 'FFFF0N00000000009EB2',
        scene: 'nvc_other',
        success: function (data) {
          _this.checkUserBehavior(data)
        },
        fail: function (failCode) {
          window.console && console.log(failCode)
        },
        error: function (errorCode) {
          window.console && console.log(errorCode)
        },
      })
    })
  },
}
</script>

<style lang="stylus" scoped>
.login-model
  >>> .ivu-form-item-error-tip
    padding-top 3px
    color #FC3B3B
  >>> .ivu-modal-close
    top 10px
    &:hover
      i
        color #FA7A50
  >>> .ivu-modal-wrap
    display flex
    align-items center
    justify-content center
  >>> .ivu-modal
    position relative
    top auto
    .ivu-modal-close
      width 20px
      height 20px
      border-radius 50%
      display flex
      align-items center
      justify-content center
      background rgba(0, 0, 0, 0.3)
      right 16px
      top 20px
      i
        font-size 24px
        color #fff
        top 0
    .ivu-modal-content
      border-radius 10px
      background-clip initial
      .ivu-modal-body
        padding 0
.container-wrapper
  width 100%
  height 408px
  display flex
  .model-bg
    flex 0 0 170px
    max-width 170px
    min-width 170px
  .container-content
    flex 0 0 360px
    max-width 360px
    min-width 360px
    padding 20px
    display flex
    flex-direction column
    justify-content space-between
    position relative
    .container-title
      font-size 18px
      font-weight 400
      color #3D3D3D
      line-height 25px
    .reset-form-title
      margin-bottom 32px
    >>> .ivu-tabs
      margin-top 30px
      .ivu-tabs-bar
        border-bottom 0
        margin-bottom 20px
      .ivu-tabs-nav-container
        margin-bottom 0
        line-height 1
      .ivu-tabs-nav
        width 100%
        display flex
        justify-content space-between
        padding 0 20px
        .ivu-tabs-ink-bar
          display none
        .ivu-tabs-tab
          padding 0
          margin-right 0
          color #999999
          position relative
          padding-bottom 10px
          font-size 16px
          line-height 22px
        .ivu-tabs-tab-active
          color #333333
          &:before
            content ''
            position absolute
            width 36px !important
            height 2px
            background #FA5A00
            border-radius 1px
            bottom 2px
            left 50%
            transform translateX(-50%)
        &:after, &:before
          content none
    >>> .ivu-form
      padding-bottom 16px
      .form-bottom
        display flex
        justify-content space-between
        span
          font-size 12px
          font-weight 400
          color #FA5A00
          cursor pointer
          &.spa1
            color #2d8cf0
            &:hover
              color #1c87fa
          &:hover
            color #FF4800
      .ivu-form-item
        margin-bottom 0
        min-height 40px
        &+.ivu-form-item
          margin-top 8px
        .ivu-form-item-content
          line-height 1
          .ivu-form-item-error-tip
            position relative
            top auto
            left auto
            font-size 12px
            color #FC3B3B
            padding 0 0 0 10px
          .code-btn
            position absolute
            z-index 2
            font-size 14px
            font-weight 400
            color #FA5A00
            line-height 1
            right 10px
            top 12px
            cursor pointer
            &:hover
              color #FF4800
            &.disabled-btn
              color #999999
          .ivu-input-suffix
            width 40px
            i
              line-height 40px
              cursor pointer
              color #666
          .ivu-input
            height 40px
            background #F2F3F5
            font-size 14px
            color #333333
            line-height 20px
            border-color #F2F3F5
            box-shadow none
            outline none
            margin-bottom 6px
        &.ivu-form-item-error
          .ivu-input
            border-color #FC3B3B
    .container-bottom
      position absolute
      bottom 20px
      left 20px
      right 20px
      .tip
        font-size 12px
        font-weight 400
        color #999999
        line-height 1
        text-align center
        margin-bottom 10px
      .submit-btn
        width 100%
        height 40px
        background #FA5A00
        border-radius 6px
        transition all 0.3s
        border 0
        font-size 14px
        font-weight 400
        color #FFFFFF
        line-height 1
        box-shadow none
        outline none
        &:hover
          background #FF4800
      .checkbox-container
        position relative
        .checkbox-tip-content
          position absolute
          top -48px
          left -13px
          .checkbox-tip-arrow
            position absolute
            width 0
            height 0
            border-color transparent
            border-style solid
            bottom -5px
            border-width 5px 5px 0
            border-top-color rgba(70, 76, 91, 0.9)
            left 15px
          .checkbox-tip-inner
            padding 8px 12px
            color #fff
            text-align left
            text-decoration none
            background-color rgba(70, 76, 91, 0.9)
            border-radius 4px
            box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
            white-space nowrap
            width fit-content
      >>> .ivu-checkbox-wrapper
        display flex
        align-items center
        margin-top 16px
        .ivu-checkbox-checked
          .ivu-checkbox-inner
            border-color #FA5A00
            background-color #FA5A00
        .ivu-checkbox-disabled.ivu-checkbox-checked
          .ivu-checkbox-inner:after
            border-color #fff
        .checkbox-label
          font-size 12px
          font-weight 400
          color #3D3D3D
          line-height 14px
          margin-left 6px
          padding-bottom 1px
          a
            cursor pointer
            color #1572E7
            &:hover
              color #2d8cf0
.code-app
  display flex
  flex-direction column
  align-items center
  margin-top -10px
  .scan-view
    text-align center
    margin-top 30px
    font-size 0
    img
      width 60px
      height 60px
    .p1
      margin-top 10px
      font-weight 500
      font-size 16px
      color #3D3D3D
      line-height 22px
    .p2
      margin-top 10px
      font-weight 400
      font-size 14px
      color #3D3D3D
      line-height 20px
  .wxcode-img
    width 120px
    height 120px
    background-color #f0f0f0
    margin-top 10px
    position relative
    img
      width 100%
      height 100%
    .wxcode-p
      position absolute
      position absolute
      top 0
      background rgba(255, 255, 255, 0.9)
      bottom 0
      right 0
      left 0
      display flex
      justify-content center
      align-items center
      flex-direction column
      p
        color #333
  .linp1
    font-size 14px
    color #333333
    line-height 20px
    font-weight 600
    text-align center
    .vb
      color #FA5A00
    .wx
      color #07C160
  .other-font
    position relative
    margin 16px 0
    width 100%
    &::before
      content ''
      border-bottom 1px solid #EEEEEE
      position absolute
      right 30px
      left 30px
      top 0
    span
      position absolute
      padding 0 20px
      background #fff
      left 50%
      top -7px
      font-size 12px
      color #999999
      line-height 17px
      transform translate(-50%, 0)
  .other-list
    display flex
    .other-icon
      width 36px
      min-width 36px
      height 36px
      background #F8F8FA
      border-radius 50%
      overflow hidden
      display flex
      align-items center
      justify-content center
      cursor pointer
      transition all 0.3s
      img
        width 16px
        height 16px
      &:hover
        background #eee
</style>
